import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ErrorHandlerComponent } from './error-handler.component';


@NgModule({
  declarations: [ErrorHandlerComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [ErrorHandlerComponent]
})
export class ErrorHandlerModule { }
